import { Box, HStack, Icon, Label, Text, VStack } from '@medely/ui-kit';
import { useProNavigate } from '@mp/contexts';
import React from 'react';

export const MissingInfoCard = ({ assignmentId }: { assignmentId: number }) => {
  const { navigate } = useProNavigate();

  return (
    <Box
      p={2}
      borderColor="controls.outline"
      borderWidth={1}
      borderRadius="10px"
      bgColor="surface.backing-1"
      onClick={() => navigate('GoToAssignmentChecklist', { assignmentId })}
    >
      <HStack alignItems="center" justifyContent="space-between">
        <VStack>
          <Label size="l" color="text.primary">
            Your application is missing information
          </Label>
          <Text size="l" color="text.secondary">
            Complete your profile to be considered for this assignment.
          </Text>
        </VStack>
        <Icon name="chevron-right" variant="custom" color="state.teal.primary" />
      </HStack>
    </Box>
  );
};
